import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { QRCodeSVG } from "qrcode.react";
import {
  setupTwoFactor,
  confirmTwoFactor,
  disableTwoFactor,
} from "../../services/twoFactorService";

export default function TwoFactorSettings({ user, onStatusChange }) {
  const [enabled, setEnabled] = useState(user?.otp_required_for_login || false);
  const [otpQr, setOtpQr] = useState("");
  const [showQr, setShowQr] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSetup = async () => {
    try {
      setLoading(true);
      const data = await setupTwoFactor();
      setOtpQr(data.otp_qr);
      setShowQr(true);
      toast.info("Escanea el código con tu app 2FA y luego confirma");
    } catch (error) {
      toast.error("Error al generar QR de 2FA");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const updatedUser = await confirmTwoFactor(otpCode); // asumimos que retorna el user
      setEnabled(true);
      onStatusChange(updatedUser);
      setShowQr(false);
      setOtpCode("");
      toast.success("2FA activado correctamente");

      if (onStatusChange) {
        onStatusChange(updatedUser); // Actualiza el estado en el padre
      }
    } catch (error) {
      toast.error("Código 2FA inválido");
    } finally {
      setLoading(false);
    }
  };

  const handleDisable = async () => {
    try {
      setLoading(true);
      const updatedUser = await disableTwoFactor(); // asumimos que retorna el user
      setEnabled(false);
      toast.success("2FA desactivado");

      if (onStatusChange) {
        onStatusChange(updatedUser); // Actualiza el padre
      }
    } catch (error) {
      toast.error("Error al desactivar 2FA");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEnabled(user?.otp_required_for_login || false);
  }, [user]);

  return (
    <Box sx={{ maxWidth: 400, margin: "auto", padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        Autenticación de dos pasos (2FA)
      </Typography>

      {enabled ? (
        <Button variant="contained" color="error" onClick={handleDisable}>
          Desactivar 2FA
        </Button>
      ) : (
        <>
          <Button variant="contained" onClick={handleSetup}>
            Activar 2FA
          </Button>
          {loading && <CircularProgress sx={{ mt: 2 }} />}
        </>
      )}

      {showQr && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="body1" gutterBottom>
            Escaneá este código QR con Google Authenticator:
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <QRCodeSVG value={otpQr} />
          </Box>
          <TextField
            label="Código 2FA"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={handleConfirm}
            fullWidth
            sx={{ mt: 2 }}
            disabled={!otpCode}
          >
            Confirmar Código
          </Button>
        </Box>
      )}
    </Box>
  );
}
